import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Seo from '@/components/Seo';

const GizlilikPolitikasi = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App">
      <Seo
        title="Gizlilik Politikası - Tilki Otomasyon"
        description="Tilki Otomasyon mobil uygulamaları ve web platformu için gizlilik politikası: toplanan veriler, kullanım amaçları, üçüncü taraflar, saklama, kullanıcı hakları ve hesap silme."
        path="/gizlilik-politikasi"
      />
      <Header />

      <main id="main-content" className="bg-white">
        <div className="mx-auto max-w-3xl px-5 py-16 md:py-20">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-ink-strong">Gizlilik Politikası</h1>
          <p className="mt-2 text-sm text-ink-muted">Son güncelleme: 27 Eylül 2026 · Yürürlük tarihi: 27 Eylül 2026</p>

          <div className="mt-8 space-y-6 text-[15px] leading-7 text-ink-muted">
            <p>
              Bu Gizlilik Politikası, <strong className="text-ink">Tilki Otomasyon</strong> ("biz", "Platform")
              tarafından sunulan web platformu ile mobil uygulamaların (Tilki Otomasyon yönetim paneli ve Tilki Sadakat
              uygulaması) kullanımı sırasında kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve
              korunduğunu açıklar.
            </p>

            <Section title="1. Veri Sorumlusu ve İletişim">
              Kişisel verileriniz, veri sorumlusu sıfatıyla Tilki Otomasyon tarafından işlenmektedir.
              <br />
              <strong className="text-ink">E-posta:</strong>{' '}
              <a href="mailto:iletisim@tilkiotomasyon.com" className="text-brand-600 hover:underline">
                iletisim@tilkiotomasyon.com
              </a>
              <br />
              <strong className="text-ink">Telefon:</strong> +90 542 254 55 35
            </Section>

            <Section title="2. Topladığımız Veriler">
              Sunduğumuz hizmetin niteliğine bağlı olarak aşağıdaki kişisel verileri toplayabiliriz:
              <ul className="mt-3 list-disc space-y-2 pl-5">
                <li>
                  <strong className="text-ink">Hesap bilgileri:</strong> ad soyad, e-posta adresi, telefon numarası ve
                  şifre (şifreler geri döndürülemez şekilde şifrelenerek saklanır).
                </li>
                <li>
                  <strong className="text-ink">Profil bilgileri:</strong> profil fotoğrafı ve isteğe bağlı iletişim
                  bilgileri.
                </li>
                <li>
                  <strong className="text-ink">İşletme ve kullanım verileri:</strong> işletme/şube bilgileri, sipariş,
                  sadakat puanı ve işlem geçmişi gibi hizmetin çalışması için gereken kayıtlar.
                </li>
                <li>
                  <strong className="text-ink">Kimlik doğrulama:</strong> Google veya Apple ile giriş yaparsanız ilgili
                  sağlayıcıdan gelen ad ve e-posta bilgisi.
                </li>
                <li>
                  <strong className="text-ink">Cihaz ve bildirim verileri:</strong> anlık bildirim (push) için cihaz
                  bildirim jetonu ve temel cihaz/uygulama bilgileri.
                </li>
              </ul>
              <p className="mt-3">Uygulamalarımız reklam amacıyla veri toplamaz ve kişisel verilerinizi satmaz.</p>
            </Section>

            <Section title="3. Verileri Kullanım Amaçlarımız">
              <ul className="mt-1 list-disc space-y-2 pl-5">
                <li>Hesabınızı oluşturmak, kimliğinizi doğrulamak ve oturumunuzu yönetmek,</li>
                <li>Sipariş, sadakat programı ve işletme yönetimi gibi temel hizmetleri sağlamak,</li>
                <li>Size işlem, kampanya ve bilgilendirme amaçlı anlık bildirim göndermek,</li>
                <li>Hizmet kalitesini, güvenliğini ve performansını iyileştirmek,</li>
                <li>Yasal yükümlülüklerimizi yerine getirmek ve kötüye kullanımı önlemek.</li>
              </ul>
            </Section>

            <Section title="4. Hukuki Sebep">
              Kişisel verileriniz; sözleşmenin kurulması ve ifası, açık rızanız, meşru menfaatlerimiz ve ilgili
              mevzuattan doğan yükümlülüklerimiz kapsamında, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve
              yürürlükteki diğer mevzuata uygun olarak işlenir.
            </Section>

            <Section title="5. Verilerin Paylaşımı ve Üçüncü Taraflar">
              Hizmetin sağlanabilmesi için sınırlı olarak aşağıdaki hizmet sağlayıcılarla çalışırız:
              <ul className="mt-3 list-disc space-y-2 pl-5">
                <li>
                  <strong className="text-ink">Google (Firebase Cloud Messaging):</strong> anlık bildirimlerin
                  iletilmesi.
                </li>
                <li>
                  <strong className="text-ink">Google / Apple:</strong> tercih etmeniz halinde giriş kimlik doğrulaması.
                </li>
                <li>
                  <strong className="text-ink">Cloudinary:</strong> yüklenen görsellerin (profil, ürün) barındırılması
                  ve optimize edilmesi.
                </li>
                <li>
                  <strong className="text-ink">Barındırma/altyapı sağlayıcıları:</strong> verilerin güvenli sunucularda
                  saklanması.
                </li>
              </ul>
              <p className="mt-3">
                Verileriniz yalnızca yasal zorunluluk halinde yetkili kamu kurumlarıyla paylaşılabilir; pazarlama
                amacıyla üçüncü taraflara satılmaz veya kiralanmaz.
              </p>
            </Section>

            <Section title="6. Veri Saklama">
              Kişisel verilerinizi yalnızca bu politikada belirtilen amaçlar için ve ilgili mevzuatın öngördüğü süreler
              boyunca saklarız. Hesabınızı sildiğinizde, yasal saklama yükümlülüğü bulunmayan kişisel verileriniz
              silinir veya anonim hale getirilir.
            </Section>

            <Section title="7. Hesabınızı ve Verilerinizi Silme">
              <div className="rounded-xl border border-hairline bg-surface-2 p-4">
                Hesabınızı ve ilişkili kişisel verilerinizi doğrudan uygulama içinden silebilirsiniz:{' '}
                <strong className="text-ink">Profil &rarr; Hesabı Sil</strong> adımını izleyin. Alternatif olarak{' '}
                <a href="mailto:iletisim@tilkiotomasyon.com" className="text-brand-600 hover:underline">
                  iletisim@tilkiotomasyon.com
                </a>{' '}
                adresine talep göndererek hesabınızın ve verilerinizin silinmesini isteyebilirsiniz.
              </div>
            </Section>

            <Section title="8. Veri Güvenliği">
              Verilerinizi korumak için şifreleme, erişim kısıtlamaları ve güvenli iletişim (HTTPS) dâhil uygun teknik
              ve idari tedbirleri uygularız. Şifreler geri döndürülemez biçimde saklanır.
            </Section>

            <Section title="9. Çerezler">
              Web sitemiz temel işlevsellik ve iyileştirme amacıyla sınırlı çerezler kullanabilir. Tarayıcı
              ayarlarınızdan çerez tercihlerinizi yönetebilirsiniz. Mobil uygulamalarımız reklam çerezleri kullanmaz.
            </Section>

            <Section title="10. Çocukların Gizliliği">
              Hizmetlerimiz 18 yaş altındaki kişilere yönelik değildir ve bilerek bu kişilerden kişisel veri toplamayız.
            </Section>

            <Section title="11. Haklarınız (KVKK md. 11)">
              Kişisel verilerinizin işlenip işlenmediğini öğrenme, bilgi talep etme, düzeltilmesini veya silinmesini
              isteme, işlemeye itiraz etme ve kanunda öngörülen diğer haklara sahipsiniz. Bu haklarınızı kullanmak için{' '}
              <a href="mailto:iletisim@tilkiotomasyon.com" className="text-brand-600 hover:underline">
                iletisim@tilkiotomasyon.com
              </a>{' '}
              adresinden bize ulaşabilirsiniz.
            </Section>

            <Section title="12. Değişiklikler">
              Bu politikayı zaman zaman güncelleyebiliriz. Önemli değişikliklerde bu sayfayı ve güncelleme tarihini
              revize ederiz. Güncel sürüm her zaman bu sayfada yayımlanır.
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const Section = ({ title, children }) => (
  <section>
    <h2 className="mb-2 font-display text-xl font-semibold text-ink-strong">{title}</h2>
    <div>{children}</div>
  </section>
);

export default GizlilikPolitikasi;
